const testimonials = [
  {
    name: "Elizabeth M.",
    location: "Naples, FL",
    rating: 5,
    text: "We booked a last-minute villa in Tuscany and realized my passport had expired six months ago. I called Fast Passport Center from Fifth Avenue South on a Tuesday afternoon. They reviewed my documents, I shipped overnight from Naples, and my new passport arrived Friday morning. The level of service was exactly what you would expect in this town — discreet, professional, and flawless.",
    service: "Passport Renewal",
  },
  {
    name: "James R.",
    location: "Marco Island, FL",
    rating: 5,
    text: "I am retired and planned a Caribbean cruise leaving from Fort Lauderdale in ten days. My wife found my passport in a drawer and it was water-damaged from our boat. Fast Passport Center walked me through the replacement process, handled the expedited submission, and I had a new passport with three days to spare. Outstanding service.",
    service: "Damaged Passport Replacement",
  },
  {
    name: "Patricia W.",
    location: "Bonita Springs, FL",
    rating: 5,
    text: "My daughter is getting married in the south of France next month and half the family needed passport renewals. Fast Passport Center handled all five applications, caught a naming inconsistency on one form, and had every passport back within a week. I have worked with concierge services my entire life — this was that caliber.",
    service: "Family Passport Renewals",
  },
];

function Stars({ count }: { count: number }) {
  return (
    <div className="flex items-center gap-0.5">
      {Array.from({ length: count }).map((_, i) => (
        <i key={i} className="ri-star-fill text-[#F6C344] text-sm"></i>
      ))}
    </div>
  );
}

export default function NaplesTestimonialsSection() {
  return (
    <section className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Reviews</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            What Southwest Florida Travelers Say
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            Real reviews from Naples, Marco Island, and Bonita Springs travelers who trusted Fast Passport Center with their expedited passports.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {testimonials.map((t, i) => (
            <div
              key={i}
              className="bg-white border border-gray-200 rounded-lg p-6 flex flex-col"
            >
              <Stars count={t.rating} />
              <p className="text-gray-600 text-sm leading-relaxed mt-4 flex-1 italic">
                &ldquo;{t.text}&rdquo;
              </p>
              <div className="mt-5 pt-4 border-t border-gray-200 flex items-center justify-between">
                <div>
                  <p className="font-bold text-[#1A365D] text-sm">{t.name}</p>
                  <p className="text-gray-400 text-xs">{t.location}</p>
                </div>
                <span className="text-xs font-semibold text-[#F6C344] bg-[#F6C344]/10 px-2.5 py-1 rounded-full whitespace-nowrap">
                  {t.service}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}